import type { DuplicateListResponse } from '@hearth/shared';
import { useQuery } from '@tanstack/react-query';
import type { RouteObject } from 'react-router';
import { api } from '../../lib/api';
import { DuplicateComparePage } from './DuplicateComparePage';
import { DuplicatesPage } from './DuplicatesPage';

export const routes: RouteObject[] = [
  { path: '/duplicates', element: <DuplicatesPage /> },
  { path: '/duplicates/:id', element: <DuplicateComparePage /> },
];

/** Sidebar badge: pairs waiting for review. */
export function useNavCount(): number | undefined {
  const { data } = useQuery({
    queryKey: ['duplicates', 'list', 'pending'],
    queryFn: ({ signal }) => api.get<DuplicateListResponse>('/api/duplicates?status=pending&pageSize=100', { signal }),
    staleTime: 60_000,
    select: (list) => list.counts.pending,
  });
  return data;
}
